import React from "react";
import PropTypes from "prop-types";

import mock from "./NestedDropDown.json";
import { NestedDropDown } from "./NestedDropDown";

NestedDropDownComponent.propTypes = {
  data: PropTypes.any,
  width: PropTypes.string,
  label: PropTypes.string,
  onSelect: PropTypes.func,
};

export function NestedDropDownComponent(props) {
  const { data } = props;
  const { onSelect } = props;
  const { width } = props;
  const { label } = props;
  console.log("data", data);

  // Adapt the data here to match the JSON
  const adaptedData = mock.array;

  return (
    <NestedDropDown
      items={adaptedData}
      onSelect={onSelect}
      width={width}
      label={label}
    />
  );
}
